<template>
  <div
    :class="{
      'hero--hide-bottom-border': hero.primary.hide_bottom_border === 'true'
    }"
    class="hero-container"
  >
    <div class="hero">
      <div class="hero__left">
        <Icon :icon="hero.primary.icon" />
        <RichText :field="hero.primary.header" class="marked" />
        <RichText :field="hero.primary.content" />
      </div>
      <div
        v-if="hero.primary.app_download_buttons === 'true'"
        class="hero__right"
      >
        <a
          href="https://apps.apple.com/sa/app/meqyas/id1266594528"
          target="_blank"
        >
          <img src="/img/download-ios.svg" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=sa.gov.citc.app"
          target="_blank"
        >
          <img src="/img/download-android.svg" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon';

export default {
  components: {
    Icon
  },
  props: {
    hero: {
      type: Object,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../scss/base/colors';
@import '../scss/helpers/mixins';

.hero-container:not(.hero--hide-bottom-border) {
  border-bottom: 1px $grey-3 solid;
  margin-bottom: 30px;
}

.hero {
  max-width: 1000px;
  margin: 30px auto;
  padding: 0 20px;

  .icon {
    font-size: 2em;
  }

  &__right a {
    display: inline-block;
    max-width: 50%;

    img {
      max-width: 100%;
    }
  }
}

@include breakpoint(M) {
  .hero-container:not(.hero--hide-bottom-border) {
    margin-bottom: 50px;

    .hero {
      margin-bottom: 60px;
    }
  }

  .hero {
    display: flex;
    align-items: center;
    margin-top: 50px;

    &__left {
      flex: 1;

      ::v-deep p {
        max-width: 600px;
      }
    }

    &__right {
      width: 200px;
      a {
        display: block;
        max-width: none;
      }
    }
  }
}
</style>
